import { render, staticRenderFns } from "./panel.page.vue?vue&type=template&id=23eecbba&"
import script from "./panel.page.vue?vue&type=script&lang=js&"
export * from "./panel.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports